module.exports = __webpack_public_path__ + "img/fi.0e5ef3f5.svg";